import { render, staticRenderFns } from "./ReflectionReadOnly.vue?vue&type=template&id=bf2c7cee&scoped=true&"
import script from "./ReflectionReadOnly.vue?vue&type=script&lang=js&"
export * from "./ReflectionReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./ReflectionReadOnly.vue?vue&type=style&index=0&id=bf2c7cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2c7cee",
  null
  
)

export default component.exports